define(["require", "exports", "three", "./Brick"], function (require, exports, THREE, Brick_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Ball extends THREE.Object3D {
        constructor(size) {
            super();
            this.size = size;
            var ballGeometry = new THREE.BoxGeometry(size, size, size, 1, 1, 1);
            var ballMaterial = new THREE.MeshPhongMaterial({ color: 0xFFFFFF });
            var ballMesh = new THREE.Mesh(ballGeometry, ballMaterial);
            this.add(ballMesh);
            this.raycaster = new THREE.Raycaster();
            this.raycaster.far = size;
            this.init();
        }
        init() {
            this.position.set(0, 0, 5);
            this.ballDirection = new THREE.Vector3(Math.random() - 0.5, 0, 0.5);
            this.ballDirection.normalize();
            this.ballSpeed = 25;
            this.ballMove = new THREE.Vector3();
        }
        update(deltaTime, level, player) {
            let halfSize = this.size / 2.0;
            // Check collision for each ball edge
            var nearestIntersection = this.checkCollision(new THREE.Vector3(-halfSize, 0, -halfSize), level, null);
            nearestIntersection = this.checkCollision(new THREE.Vector3(halfSize, 0, -halfSize), level, nearestIntersection);
            nearestIntersection = this.checkCollision(new THREE.Vector3(halfSize, 0, halfSize), level, nearestIntersection);
            nearestIntersection = this.checkCollision(new THREE.Vector3(-halfSize, 0, halfSize), level, nearestIntersection);
            if (nearestIntersection) {
                if (nearestIntersection.object === player) {
                    // Player, adjust outbound angle by hit position
                    var xPositionDistance = THREE.Math.clamp((this.position.x - player.position.x) / 4, -4, 4);
                    this.ballDirection.set(xPositionDistance, 0, -1);
                    this.ballDirection.normalize();
                }
                else if (nearestIntersection.object instanceof Brick_1.Brick) {
                    level.remove(nearestIntersection.object);
                    this.ballDirection.reflect(nearestIntersection.face.normal);
                }
                else {
                    this.ballDirection.reflect(nearestIntersection.face.normal);
                }
            }
            let ballPosition = this.position;
            ballPosition.add(this.ballMove.copy(this.ballDirection).multiplyScalar(this.ballSpeed * deltaTime));
            this.position.copy(ballPosition);
        }
        checkCollision(offset, level, previousIntersection) {
            let rayStart = new THREE.Vector3();
            rayStart.copy(this.position);
            rayStart.add(offset);
            this.raycaster.set(rayStart, this.ballDirection);
            let intersections = this.raycaster.intersectObjects(level.children);
            let firstIntersection = intersections.length > 0 ? intersections[0] : null;
            if (firstIntersection
                && firstIntersection.distance < this.ballMove.length()
                && (!previousIntersection || previousIntersection.distance > firstIntersection.distance)) {
                return firstIntersection;
            }
            return previousIntersection;
        }
    }
    exports.Ball = Ball;
});



//////////////////
// WEBPACK FOOTER
// ./src/Ball.ts
// module id = 5
// module chunks = 0